"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var common_utils_1 = require("../../tools/common-utils");
var CheckComponent_1 = require("./CheckComponent");
var horizontalSpace = 'squid-mr-component-checkbox-space-wide';
var spacing = {
    checkbox: {
        wide: 'squid-mb-component-checkbox-space-wide',
        tight: 'squid-mb-component-checkbox-space-tight',
        base: 'squid-mb-component-checkbox-space-base',
    },
    radio: {
        wide: 'squid-mb-component-radio-space-wide',
        tight: 'squid-mb-component-radio-space-tight',
        base: 'squid-mb-component-radio-space-base',
    },
};
var InputGroup = function (_a) {
    var type = _a.type, name = _a.name, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b, _c = _a.numColumns, numColumns = _c === void 0 ? 1 : _c, _d = _a.space, space = _d === void 0 ? 'base' : _d, items = _a.items, _e = _a.defaultValues, defaultValues = _e === void 0 ? [] : _e, onSelect = _a.onSelect, onSelectAll = _a.onSelectAll, onClearAll = _a.onClearAll, forwardedRef = _a.forwardedRef;
    var _f = (0, react_1.useState)(type === 'checkbox' || defaultValues.length < 0
        ? defaultValues
        : [defaultValues[0]]), selectedItems = _f[0], setSelectedItems = _f[1];
    var _g = (0, react_1.useState)([]), values = _g[0], setValues = _g[1];
    var isVertical = (0, react_1.useMemo)(function () { return orientation === 'vertical'; }, [orientation]);
    (0, react_1.useEffect)(function () {
        var cols = isVertical ? 1 : numColumns || 1;
        if (cols === 1 && !isVertical) {
            setValues([items]);
        }
        else {
            setValues((0, common_utils_1.columns)(items, cols));
        }
    }, [numColumns, items, isVertical]);
    var handleChange = function (index, item) {
        return function (checked) {
            var updated;
            if (type === 'checkbox') {
                if (checked) {
                    updated = __spreadArray(__spreadArray([], selectedItems, true), [index], false);
                }
                else {
                    updated = selectedItems.filter(function (x) { return x !== index; });
                }
            }
            else {
                updated = [index];
            }
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(index, item, checked);
            setSelectedItems(updated);
        };
    };
    var handleClearAll = function () {
        setSelectedItems([]);
        onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
    };
    var handleSelectAll = function () {
        var selectedIndexes = [];
        var selectedValues = [];
        var itemIndex = 1;
        values.forEach(function (row) {
            row.forEach(function (val) {
                selectedValues.push(val);
                selectedIndexes.push(itemIndex);
                itemIndex++;
            });
        });
        setSelectedItems(selectedIndexes);
        onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(selectedValues);
    };
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({
        selectAll: handleSelectAll,
        clearAll: handleClearAll,
    }); });
    var index = 0;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: values.map(function (row, rowIndex) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)({
                    'squid-flex': numColumns > 1 && !isVertical,
                    'squid-flex-col': numColumns > 1 && isVertical,
                    'squid-flex-row': numColumns > 1 && !isVertical,
                }, spacing[type][space]) }, { children: row.map(function (item, colIndex) {
                    var label = ['string', 'number'].includes(typeof item)
                        ? item.toString()
                        : item.label;
                    var helpText = ['string', 'number'].includes(typeof item)
                        ? undefined
                        : item.helpText;
                    index++;
                    return ((0, jsx_runtime_1.jsx)(CheckComponent_1.CheckComponent, { id: label, name: type === 'radio' ? name : label, type: type, label: label, helpText: helpText, checked: selectedItems.includes(index), onChange: handleChange(index, item), containerClassName: isVertical ? undefined : horizontalSpace }, "".concat(label, "_").concat(colIndex)));
                }) }), "row_".concat(rowIndex)));
        }) }));
};
exports.InputGroup = InputGroup;
exports.default = exports.InputGroup;
